import React from 'react';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import { token } from '@atlaskit/tokens';
import { checkForSvg } from './utils.tsx';

// got this value through trial and error
// in the long term, we should change the color of icon generated for the conntect apps
const colorMatrixValues = '0.08, 0, 0, 0, 0, 0, 0.1, 0, 0, 0, 0, 0,0.2, 0, 0, 0, 0, 0, 1, 0';

export type IconCustomProps = {
	shouldChangeFillColor?: boolean;
	url: string;
	ariaLabelledBy?: string;
};

export const IconCustom = ({
	url,
	shouldChangeFillColor = true,
	ariaLabelledBy,
}: IconCustomProps): React.JSX.Element => {
	return (
		<Box xcss={styles}>
			<svg viewBox="0 0 20 20">
				<defs>
					<filter id="changeFillColor">
						<feColorMatrix type="matrix" values={colorMatrixValues} />
					</filter>
				</defs>
				<image
					xmlnsXlink="http://www.w3.org/1999/xlink"
					xlinkHref={url}
					width="20"
					height="20"
					x="0"
					y="0"
					filter={shouldChangeFillColor && checkForSvg(url) ? 'url(#changeFillColor)' : ''}
					aria-labelledby={ariaLabelledBy}
				/>
			</svg>
		</Box>
	);
};

const styles = xcss({
	display: 'inline-block',
	margin: 'space.025',
	height: token('space.250'),
	width: token('space.250'),
});
